<template>
  <div :class="$style.statsContainer">
    <!-- 统计卡片容器 -->
    <div :class="$style.statsCard" v-loading="loading" element-loading-text="统计加载中...">
      <!-- 四列网格布局 -->
      <div :class="$style.statsGrid">
        <!-- 总金额 -->
        <div :class="$style.statsItem">
          <div :class="$style.statsIcon" :style="{background: '#ecf5ff', color: '#409EFF'}">
            <i class="el-icon-money"></i>
          </div>
          <div :class="$style.statsContent">
            <div :class="$style.statsLabel">发票总金额</div>
            <div :class="$style.statsValue">{{ formatCurrency(stats.total_amount || 0) }} 元</div>
          </div>
        </div>
        
        <!-- 已关联 -->
        <div :class="$style.statsItem">
          <div :class="$style.statsIcon" :style="{background: '#f0f9eb', color: '#67C23A'}">
            <i class="el-icon-success"></i>
          </div>
          <div :class="$style.statsContent">
            <div :class="$style.statsLabel">已关联发票</div>
            <div :class="$style.statsValue">
              <span :class="$style.statsSubValue">条数：{{ (stats.binded && stats.binded.count) || 0 }}</span>
              <span :class="$style.statsSubValue">总金额：{{ formatCurrency((stats.binded && stats.binded.amount) || 0) }} 元</span>
              <span :class="$style.statsSubValue">正常金额：{{ formatCurrency((stats.binded && stats.binded.normal) || 0) }} 元</span>
              <span :class="$style.statsSubValue">红冲或作废：{{ formatCurrency((stats.binded && stats.binded.abnormal) || 0) }} 元</span>
            </div>
          </div>
        </div>
        
        <!-- 未关联 -->
        <div :class="$style.statsItem">
          <div :class="$style.statsIcon" :style="{background: '#fdf6ec', color: '#E6A23C'}">
            <i class="el-icon-warning"></i>
          </div>
          <div :class="$style.statsContent">
            <div :class="$style.statsLabel">未关联发票</div>
            <div :class="$style.statsValue">
              <span :class="$style.statsSubValue">条数：{{ (stats.unbinded && stats.unbinded.count) || 0 }}</span>
              <span :class="$style.statsSubValue">总金额：{{ formatCurrency((stats.unbinded && stats.unbinded.amount) || 0) }} 元</span>
              <span :class="$style.statsSubValue">正常金额：{{ formatCurrency((stats.unbinded && stats.unbinded.normal) || 0) }} 元</span>
              <span :class="$style.statsSubValue">红冲或作废：{{ formatCurrency((stats.unbinded && stats.unbinded.abnormal) || 0) }} 元</span>
            </div>
          </div>
        </div>
        
        <!-- 总条数 -->
        <div :class="$style.statsItem">
          <div :class="$style.statsIcon" :style="{background: '#f4f4f5', color: '#909399'}">
            <i class="el-icon-document"></i>
          </div>
          <div :class="$style.statsContent">
            <div :class="$style.statsLabel">发票总条数</div>
            <div :class="$style.statsValue">
              {{ ((stats.binded && stats.binded.count) || 0) + ((stats.unbinded && stats.unbinded.count) || 0) }} 条
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InvoiceStats',
  props: {
    stats: {
      type: Object,
      default: () => ({ total_amount: 0, binded: { count: 0, amount: 0 }, unbinded: { count: 0, amount: 0 } })
    },
    loading: { type: Boolean, default: false }
  },
  methods: {
    formatCurrency(amount) {
      return Number(amount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
  }
}
</script>

<style module>
.statsContainer {
  width: 100%;
  margin-bottom: 20px;
}

.statsCard {
  background: #fff;
  border-radius: 6px;
  padding: 20px;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
}

.statsGrid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
}

.statsItem {
  display: flex;
  align-items: center;
  padding: 16px;
  background: #f9fafc;
  border-radius: 6px;
  border-left: 3px solid #409EFF;
  transition: all 0.3s;
}

.statsItem:hover {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.statsItem:nth-child(1) {
  border-left-color: #409EFF;
}

.statsItem:nth-child(2) {
  border-left-color: #67C23A;
}

.statsItem:nth-child(3) {
  border-left-color: #E6A23C;
}

.statsItem:nth-child(4) {
  border-left-color: #909399;
}

.statsIcon {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
  font-size: 24px;
}

.statsContent {
  flex: 1;
}

.statsLabel {
  font-size: 14px;
  color: #606266;
  margin-bottom: 6px;
  line-height: 1.2;
}

.statsValue {
  font-size: 18px;
  color: #303133;
  font-weight: 600;
  line-height: 1.3;
}

.statsSubValue {
  display: block;
  font-size: 14px;
  font-weight: normal;
  margin-top: 4px;
}

.statsSubValue:first-of-type {
  margin-top: 0;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .statsGrid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .statsGrid {
    grid-template-columns: 1fr;
  }
  
  .statsIcon {
    width: 40px;
    height: 40px;
    font-size: 20px;
  }
  
  .statsValue {
    font-size: 16px;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/invoice_record/components/InvoiceStats.vue